import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter, Link } from 'react-router-dom'
import { logout } from 'Features/auth/actions'
import { getIsLoggedIn } from 'Features/auth/selectors'
import { Icon, Menu, Container, Image, Dropdown } from 'semantic-ui-react'
import { /*getServiceToken,*/ getUserFirstName, getIsUserActiveDirectory, getSystem } from 'Lib'
// const trigger = (
//     <span><Icon name='user' /></span>
// )
const header = {
    textDecoration: 'underline',
    fontSize: '1em'
}


const NoAuthHeader = () => (
    <div></div>
)

// const AuthHeader = ({ logout }) => (
class AuthHeader extends React.Component {
    constructor(props) {
        super(props)
        // const bsrs = getServiceToken()
        const firstName = getUserFirstName()
        const isUseAD = getIsUserActiveDirectory()
        const system = getSystem()
        // const { user_id } = bsrs
        this.state = ({
            // isProfile: user_id === 'profile_user' ? true : false,
            isProfile: true,
            logout: props.logout,
            firstName: typeof firstName !== 'undefined' ? firstName : '',
            isUseAD: isUseAD ? isUseAD : false,
            system: system
        })
    }
    render() {
        let linkToInt = ''
        if (getSystem() === 'o365')
            linkToInt = '/integration'
        else if (getSystem() === 'exchange2013')
            linkToInt = '/exchangeIntegration'
        else if (getSystem() === 'google')
            linkToInt = '/googleIntegration'
        return (

            <Menu secondary fixed="top" style={{ backgroundColor: "rgb(51, 51, 51)" }}>
                <Container>
                    <Menu.Item as={Link} to='/' className="menuImage">
                        <Image
                            size='small'
                            src='/assets/images/logo.png'
                            style={{ marginRight: '1em' }}
                        />
                    </Menu.Item>
                    <Dropdown item text='Master Data' id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown item text='Rooms'>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/room/o365'><Icon name='window restore' />Mail System Rooms</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/room/core'><Icon name='database' />Room Registeration</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/room/subscribe'><Icon name='bell' />Room Subscription</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/roomdisable'><Icon name='ban' />Room Disable</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown item text='Location'>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/building'><Icon name='building' />Building</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/floor'><Icon name='hashtag' />Floor</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/zone'><Icon name='star' />Zone</Dropdown.Item>
                                    {/* <Dropdown item text='Seat'>
                                        <Dropdown.Menu>
                                            <Dropdown.Item as={Link} to='/registerseat'><Icon name='cubes' />All Seat</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown> */}
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown item text='Users' id="menuHover">
                                <Dropdown.Menu>
                                    {/* <Dropdown.Item as={Link} to='/user/o365'><Icon name='windows' />O365 User</Dropdown.Item> */}
                                    {
                                        this.state.isUseAD === 'true' &&
                                        <Dropdown.Item as={Link} to='/user/ad'><Icon name='adn' />AD User</Dropdown.Item>
                                    }
                                    <Dropdown.Item as={Link} to='/user/core'><Icon name='database' />User Registeration</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/user/group/list'><Icon name='users' />User Group</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown.Item as={Link} to='/profile/list'><Icon name='user' />Profile</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/background'><Icon name='flag' />Background</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/amenity' ><Icon name='briefcase' />Amenities</Dropdown.Item>
                            <Dropdown item text='Foods & Beverage'>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/fbsCategory'><Icon name='coffee' />Category</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/fbs'><Icon name='coffee' />Foods</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown item text='IoT'>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/display'><Icon name='at' />Display</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/iot'><Icon name='at' />IoT Registration</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/iotRoom'><Icon name='at' />IoT Room Config</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item text='Events' id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to='/events'><Icon name='calendar' />View Events</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* <Dropdown item text='Master' id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown item text='Users'>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/user/o365'><Icon name='windows' />O365 User</Dropdown.Item>
                                    {
                                        this.state.isUseAD === 'true' &&
                                        <Dropdown.Item as={Link} to='/user/ad'><Icon name='adn' />AD User</Dropdown.Item>
                                    }
                                    <Dropdown.Item as={Link} to='/user/core'><Icon name='database' />Regis User</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/user/group/list'><Icon name='users' />User Group</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            <Dropdown item text='Foods & Beverage'>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/fbsCategory'><Icon name='food' />Category</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/fbs'><Icon name='food' />Food</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                        </Dropdown.Menu>
                    </Dropdown> */}
                    <Dropdown item text='Settings' id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to='/setting'><Icon name='setting' />Global Setting</Dropdown.Item>
                            {
                                this.state.isProfile &&
                                <Dropdown.Item as={Link} to={linkToInt}><Icon name='cogs' />Integration</Dropdown.Item>
                            }
                            {/* {
                                this.state.isProfile &&
                                <Dropdown.Item as={Link} to='/exchangeIntegration'><Icon name='cogs' />Exchange Integration</Dropdown.Item>
                            }
                            {
                                this.state.isProfile &&
                                <Dropdown.Item as={Link} to='/googleIntegration'><Icon name='cogs' />Google Integration</Dropdown.Item>
                            } */}
                            <Dropdown.Item as={Link} to='/term'><Icon name='setting' />Terms & Conditions</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/faq'><Icon name='setting' />FAQ</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/contact'><Icon name='setting' />Contact Us</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item text='Report' id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown.Header style={header}>Summary</Dropdown.Header>
                            {/* <Dropdown.Item as={Link} to='/report/statussummary'>Status Summary</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/statussummary'>Overview</Dropdown.Item> */}
                            <Dropdown.Item as={Link} to='/report/roomsummary'> Room Summary</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/usersummary'> User Summary</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/foodsummary'> Food Summary</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/facilitysummary'> Facility Summary</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Header style={header}>Reserve Not Use</Dropdown.Header>
                            <Dropdown.Item as={Link} to='/report/notuse/room'> Room</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/notuse/user'> User</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Header style={header}>Detail</Dropdown.Header>
                            <Dropdown.Item as={Link} to='/report/roomreport'>Room Details</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/userreport'>User Details</Dropdown.Item>
                            {/* <Dropdown.Divider /> */}
                            {/* <Dropdown.Header style={header}>New Report</Dropdown.Header> */}
                            {/* <Dropdown.Item as={Link} to='/report/overview'>Overview</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/overview'>Room</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/byroom'>By Room</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/byuser'>By User</Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item text='Monitor' id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown.Header style={header}>Summary</Dropdown.Header>
                            {/* <Dropdown.Item as={Link} to='/report/statussummary'>Status Summary</Dropdown.Item> */}
                            <Dropdown.Item as={Link} to='/report/statussummary'>Overview</Dropdown.Item>
                            {/* <Dropdown.Item as={Link} to='/report/roomsummary'> Room Summary</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/usersummary'> User Summary</Dropdown.Item> */}
                            <Dropdown.Divider />
                            {/* <Dropdown.Header style={header}>Detail</Dropdown.Header>
                            <Dropdown.Item as={Link} to='/report/userreport'>User Detail</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/roomreport'>Room Detail</Dropdown.Item>
                            <Dropdown.Divider /> */}
                            <Dropdown.Header style={header}>Status</Dropdown.Header>
                            {/* <Dropdown.Item as={Link} to='/report/overview'>Overview</Dropdown.Item> */}
                            <Dropdown.Item as={Link} to='/report/overview'>Room</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/overview/user/day'>Top Users By Reservation</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/overview/room/day'>Top Rooms By Reservation</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Menu.Menu position='right' >
                        {/* <Menu.Item> */}
                        <Dropdown item text={`Hello, ${this.state.firstName}`} id="lastMenuHover" >
                            <Dropdown.Menu>
                                {/* <Dropdown.Header>O365</Dropdown.Header>
                        <Dropdown.Item as={Link} to='/settings/integration'>Integration</Dropdown.Item>
                        <Dropdown.Item as={Link} to='/room/list'><Icon namee='microsoft' />O365 Rooms</Dropdown.Item>
                        <Dropdown.Divider /> */}
                                {/* <Dropdown.Header>Regis</Dropdown.Header>
                        <Dropdown.Item as={Link} to='/room'>Regis Room</Dropdown.Item>
                        <Dropdown.Item as={Link} to='/setting/user/list'>User List</Dropdown.Item>
                        <Dropdown.Item as={Link} to='/setting/user/add'>Regis User</Dropdown.Item> */}
                                <Dropdown.Item as={Link} to='/UserInfo'>User Information</Dropdown.Item>
                                <Dropdown.Item onClick={this.state.logout}>  <Icon name='power' />Sign Out</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Menu>
                </Container>
            </Menu >

        )
    }
}

const Header = ({ isLoggedIn, logout }) => (
    <div>
        {
            isLoggedIn ? <AuthHeader logout={logout} /> : <NoAuthHeader />
        }
    </div>
)

export default compose(
    withRouter,
    connect(
        state => ({ isLoggedIn: getIsLoggedIn(state) }),
        (dispatch, props) => ({
            logout() {

                dispatch(logout())
                props.history.push('/login')
            }
        })
    )
)(Header)


// WEBPACK FOOTER //
// ./src/features/ui/components/Header.js